import React from 'react';

export const SubcategoryBody = ({ children }) => (
  <div key="subcategory-body">
    {children}
  </div>
);

SubcategoryBody.defaultProps = {
  role: 'subcategory-body'
}

export default SubcategoryBody;